import { connect } from "react-redux";
import { ThunkDispatch } from "redux-thunk";

import { ApplicationState } from "../../../redux/ApplicationState";
import { GetAuthPacketActionDispatchTypes } from "../../../constants/HomePage";
import PatientList from "../components/PatientList";
import { UserPageTrack } from "../../../models/User";
import { postUserPageTrack } from "../../../actions/UserAction";

const mapStateToProps = ({
  referralAuthHistoryState,
  authPacketDownloadState,
}: ApplicationState) => ({
  referralAuthHistory:
    referralAuthHistoryState.response,
  authPacketDownload: authPacketDownloadState.response,
});

const mapDispatchToProps = (
  dispatch: ThunkDispatch<ApplicationState, Record<string, never>, any>
) => {
  return {
    resetAuthPacket: () => {
      dispatch({
        type: GetAuthPacketActionDispatchTypes.GET_AUTH_PACKET_RESET,
      });
    },
    postUserPageTrack: (payload: UserPageTrack) => {
      dispatch(postUserPageTrack(payload));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(PatientList);
